'use client';

import { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: React.ReactNode;
}

export default function ExpandableFAQ({ question, answer }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-all duration-300 group"
        aria-expanded={isOpen ? "true" : "false"}
      >
        <h3 className="text-lg font-medium text-gray-800 leading-relaxed pr-4 group-hover:text-[#DA159B] transition-colors duration-300">
          {question}
        </h3>
        <div className="flex-shrink-0">
          <svg
            className={`w-6 h-6 text-gray-400 transition-all duration-300 flex-shrink-0 ${
              isOpen ? 'transform rotate-180 text-[#DA159B]' : 'group-hover:text-[#DA159B]'
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </button>
      <div
        className={`transition-all duration-500 ease-in-out ${
          isOpen 
            ? 'max-h-[1000px] opacity-100 pb-6' 
            : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6">
          <div className="border-t border-gray-100 pt-4">
            <div className="text-gray-700 leading-relaxed space-y-3">
              {answer}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 